import script from "./MainSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./MainSidebar.vue?vue&type=style&index=0&id=460e065a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460e065a"]])

export default __exports__